// extracted by mini-css-extract-plugin
module.exports = {"tree-section-title":"_3wMsS","treeSectionTitle":"_3wMsS"};